import { useContext, useEffect } from 'react';

import { useFeatureFlag } from 'App';
import { MeContext } from 'App/components';
import env from 'Src/env';

export default function useRedirectToLegacy({
  pathName,
}: {
  pathName: string;
}) {
  const { me } = useContext(MeContext);
  const hasNewServices = useFeatureFlag('servicesV2');

  useEffect(() => {
    const publicPathRegex = /simpleBuyer/;
    const isPublicPath = publicPathRegex.test(pathName);

    // Redirect non beta users to the legacy platform
    if (!isPublicPath && !hasNewServices && me.id) {
      const legacyUrl = `https://${env.DEPLOY_ENV}.inturn.io`;
      window.location.replace(legacyUrl);
    }
  }, [pathName]);
}
